module.exports = __webpack_public_path__ + "static/img/autumn_jianjiePic.28a3388e.png";